import { httpApi } from '@api/http.api.ts';
import type { STATISTIC_DATERANGES } from '@routes/sidebar/___shared___/constants.ts';
import type { STATISTICS_TYPES } from '@routes/sidebar/___shared___/constants.ts';

export type StatisticsType = (typeof STATISTICS_TYPES)[keyof typeof STATISTICS_TYPES];
export type StatisticDateRange = (typeof STATISTIC_DATERANGES)[keyof typeof STATISTIC_DATERANGES];

export interface CompletionPeriodValues {
    dateTimeUTCPeriod: string;
    totalCompleted: number;
    ashoreCompleted: number;
    onboardCompleted: number;
}

export interface CompletionPeriod {
    statisticDateRange: StatisticDateRange;
    values: CompletionPeriodValues[];
}

export interface MandatoryStatistics {
    totalPathways: number;
    completedPathways: number;
    firstDueUTC: string | null;
    lastDueUTC: string | null;
    overduePathways: number;
    dueSoonPathways: number;
    dueLaterPathways: number;
    upToDatePathways: number;
    progress: number;
}

export interface CalculatedStatistics {
    statisticsType: StatisticsType;
    total: number;
    totalCompleted: number;
    completionPeriods: CompletionPeriod[];
}

export interface StatisticsSummary {
    statistics: CalculatedStatistics[];
    mandatoryStatistics: MandatoryStatistics;
    totalCompleted: number;
    totalCompletedLastMonth: number;
    rankInfo: RankInfo;
}
export interface RankInfo {
    userPosition: number;
    userId: number;
    score: number;
    totalPlayers: number;
    scoreLastMonth: number;
    userPositionLastMonth: number;
}

export const geApiStatistics = (): Promise<StatisticsSummary> =>
    httpApi.get<StatisticsSummary>('statistics').then(({ data }) => data);
